import { render, staticRenderFns } from "./SmartEducation.vue?vue&type=template&id=05df2974&"
import script from "./SmartEducation.vue?vue&type=script&lang=js&"
export * from "./SmartEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports